import { NgModule } from '@angular/core';
import { AccredibleKeyboardFocusService } from './keyboard-focus.service';

@NgModule({
  providers: [AccredibleKeyboardFocusService],
})
export class AccredibleKeyboardFocusServiceModule {}
